module.exports = __webpack_public_path__ + "1b26a85fa468178e3e8838144ca3f264.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/3032_teaser_image.jpg
// module id = 617
// module chunks = 0